import * as React from "react";
import TokenHybrid from "./TokenHybrid";
import type { TypeTokenProps } from "./TokenTypes";

/**
 * Token component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props or styled() extension).
 */
const Token = (props: TypeTokenProps) => <TokenHybrid {...props} />;

Token.displayName = "Token";

export default Token;
